import { IAppState } from "..";

export const getIsSidebarOpen = (state: IAppState) => state.sidebar.isOpen;
